// extracted by mini-css-extract-plugin
module.exports =  {"title":"ThHc7HyGNym1IdVfkmeZ"};